function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import classNames from 'classnames';
import React from 'react';
import { useTheme } from './ThemeContext';
import textStyles from './styles/text.module.scss';
const styles = require('./Text-styles.module.scss');
export function useTextStyle({
  align,
  variant,
  color,
  theme,
  truncate,
  transform
}) {
  const resolvedTheme = useTheme(theme);
  return classNames(textStyles[`text-${variant}`], textStyles[transform], align && textStyles[`align-${align}`], truncate && textStyles.ellipsis, styles[`${resolvedTheme}-${color}`] || styles[color]);
} // @ts-ignore

const Text = ({
  variant = 'inherit',
  color = 'inherit',
  as: Tag = 'span',
  align,
  className,
  theme,
  truncate,
  transform,
  ...props
}) => {
  const textClasses = useTextStyle({
    theme,
    align,
    variant,
    color,
    truncate,
    transform
  });
  return React.createElement(Tag, _extends({
    className: classNames(className, textClasses)
  }, props));
};

export default Text;